module.exports = __webpack_public_path__ + "static/roomies-43cff6fa378b6801a6b3c0f713381599.gif";